import {isArray} from '@shared/helpers/lang'

import {STI_INFO, CashReceiptIssueType} from '@web/core/constants'
import {isPC} from '@web/helpers/userAgent'
import {
    UiEvent,
    uiEventLoggerCreator,
    uiEventAction,
    PageViewEvent,
    createPageViewTargetMap,
    pageViewAction,
    PageViewLoggers,
} from '@web/middlewares/uiLogging'
import {cashReceiptSelector} from '@web/slices/cashReceipt/slice'

import {nClicksMap} from '../../../constants/nClicks'
import {CheckoutRootState as RootState} from '../../../interfaces'

const pageViewLoggers: PageViewLoggers = ['lcs']

const CashReceiptMap = {
    [UiEvent.CASH_RECEIPT_CHANGE_INFO]: [
        ['ode.businesscharec', 'ord.businesscharec'],
        ['ode.privatecharec', 'ord.privatecharec'],
    ],
    [UiEvent.CASH_RECEIPT_SAVE_INFO]: [
        ['ode.businessrecsave', 'ord.businessrecsave'],
        ['ode.privaterecsave', 'ord.privaterecsave'],
    ],
}

const uiEventLogger = uiEventLoggerCreator<RootState>({
    nClicksTargetMap: nClicksMap,
    convertNClicksCode: ({state, uiEvent, value}) => {
        const {entry} = state.common
        const defaultValue = isArray(value) ? (isPC ? value[1] : value[0]) : value

        if (uiEvent === UiEvent.CASH_RECEIPT_CHANGE_INFO || uiEvent === UiEvent.CASH_RECEIPT_SAVE_INFO) {
            const {issueType} = cashReceiptSelector(state)
            const caseIndex = issueType.current === CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER ? 0 : 1
            const deviceIndex = isPC ? 1 : 0
            return CashReceiptMap[uiEvent][caseIndex]?.[deviceIndex] ?? defaultValue
        }

        if (uiEvent === UiEvent.SUBMIT_CLICK_BUTTON) {
            if (entry === 'SHOPN') {
                return isPC ? 'ord.payss' : 'ode.payss'
            }
            if (entry === 'GIFTING') {
                return 'odg.pay'
            }
            if (entry === 'BRANCH') {
                return isPC ? 'ord.paymart' : 'ode.paymart'
            }
        }

        if (uiEvent === UiEvent.FLOATING_SUBMIT_CLICK_BUTTON) {
            if (entry === 'SHOPN') {
                return isPC ? 'ord.payss_float' : 'ode.payss_float'
            }
            if (entry === 'GIFTING') {
                return 'odg.pay_float'
            }
            if (entry === 'BRANCH') {
                return isPC ? 'ord.paymart_float' : 'ode.paymart_float'
            }
        }

        if (uiEvent === UiEvent.FLOATING_MODAL_SUBMIT_CLICK_BUTTON) {
            if (entry === 'SHOPN') {
                return isPC ? 'ord.payss_floatmodal' : 'ode.payss_floatmodal'
            }
            if (entry === 'GIFTING') {
                return 'odg.pay_floatmodal'
            }
            if (entry === 'BRANCH') {
                return isPC ? 'ord.paymart_floatmodal' : 'ode.paymart_floatmodal'
            }
        }

        return defaultValue
    },
    pageViewTargetMap: createPageViewTargetMap([
        [PageViewEvent.ORDER, pageViewLoggers],
        [PageViewEvent.WAITING, pageViewLoggers],
        [PageViewEvent.BRANCH, pageViewLoggers],
        [PageViewEvent.GIFTING, pageViewLoggers],
        [PageViewEvent.NON_PURCHASABLE, pageViewLoggers],
    ]),
    pageViewLogger: {
        getLcs: ({target}) => {
            if (target === PageViewEvent.NON_PURCHASABLE) {
                return {
                    sti: isPC ? '' : STI_INFO.ORDER.MO_NON_PURCHASABLE,
                }
            }
            return {
                sti: (function () {
                    if (target === PageViewEvent.BRANCH) {
                        return isPC ? STI_INFO.ORDER.PC_BRANCH : STI_INFO.ORDER.MO_BRANCH
                    } else if (target === PageViewEvent.GIFTING) {
                        return isPC ? STI_INFO.ORDER.PC_GIFTING : STI_INFO.ORDER.MO_GIFTING
                    } else if (target === PageViewEvent.WAITING) {
                        return isPC ? STI_INFO.ORDER.PC_WAITING : STI_INFO.ORDER.MO_WAITING
                    }
                    return isPC ? STI_INFO.ORDER.PC : STI_INFO.ORDER.MO
                })(),
            }
        },
    },
})

export const uiEventActions = [uiEventAction.type, pageViewAction.type]

export default uiEventLogger
